import { render, staticRenderFns } from "./creditors_report.vue?vue&type=template&id=225c2a50"
import script from "./creditors_report.vue?vue&type=script&lang=js"
export * from "./creditors_report.vue?vue&type=script&lang=js"
import style0 from "./creditors_report.vue?vue&type=style&index=0&id=225c2a50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports